import { ProductStatus } from './constants';
import { ISelectedRetailOption, SelectedRetails } from './EditProducts/EditProductModal';
import { DealProduct, ICustomData, IProductCommonFields, IProductCommonFieldsParams, OptionInner, removedProducts } from './interfaces';

const getProductCommonFields = ({
  products,
  product,
  provider,
  rate,
  plan,
  option,
}: IProductCommonFieldsParams): IProductCommonFields => {
  let costSum = rate?.amount + option?.amount;
  const options: OptionInner[] = [];

  products.optionSelected.forEach((opt: ISelectedRetailOption) => {
    if (product.productName === opt.product.productName) {
      costSum += opt.option.optionAmount;
      options.push({
        id: opt.option.optionId,
        name: opt.option.optionDescription,
        amount: opt.option.optionAmount,
        isSurcharge: false,
      });
    }
  });

  const retailSum = costSum + rate.markup;

  return {
    productTypeName: product.productName,
    productTypeId: product.productTypeId,
    providerName: provider.providerName,
    providerId: provider.providerId,
    cost: costSum,
    markup: rate.markup,
    retail: retailSum,
    packPrice: rate.packPrice,
    providerBaseAmount: rate.providerBaseAmount,
    maxAllowedRetail: provider.maxAllowedRetail,
    sefiPlanCode: plan.sefiPlanCode,
    sefiQuoteId: plan.sefiQuoteId,
    sefiRateBook: plan.sefiRateBook,
    sefiTermId: rate.sefiTermId,
    sefiContractFormNumber: rate.sefiContractFormNumber,
    plan: {
      planId: plan.id,
      planName: plan.name,
    },
    rate: {
      rateId: rate.rateId,
      minTerm: rate.minTerm,
      maxTerm: rate.maxTerm,
      maxMiles: rate.maxMiles,
    },
    deductible: {
      id: option.deductibleId,
      name: option.deductibleDescription,
      amount: option.amount,
    },
    options,
  };
};

export const getPostDataToSaveEditProducts = (products: SelectedRetails, dealId: string) => {
  const dealProducts: (IProductCommonFields | DealProduct | removedProducts)[] = [];
  products.dealsProductsMap.forEach((product: DealProduct) => {
    if (product.status !== ProductStatus.CONTRACTED) {
      if (Array.from(products.optionSelected.values())?.length > 0) {
        const updatedOptions: OptionInner[] = [];
        products.optionSelected.forEach((item) => {
          if (item.rate.rateId === product.rate.rateId) {
            updatedOptions.push({ id: item.option.optionId, name: item.option.optionDescription, amount: item.option.optionAmount, isSurcharge: item.option.isSurcharge });
          }
        });
        product.options = updatedOptions;
      } else {
        product.options = [];
      }
      dealProducts.push(product);
    }
  });
  products.deductiblesSelected.forEach(({ product, provider, plan, rate, option, dealProductId }) => {
    const isAlreadyExist = products.dealsProductsMap.get(product.productTypeId);

    if (!isAlreadyExist) {
      dealProducts.push({
        dealId,
        dealProductId,
        ...getProductCommonFields({ products, product, provider, rate, plan, option }),
      });
    } else {
      const index = dealProducts.findIndex((product) => product.productTypeId === isAlreadyExist.productTypeId);
      const updateRate = {
        ...rate, markup: (dealProducts[index] as DealProduct).markup
      };
      dealProducts[index] = {
        dealId,
        dealProductId,
        ...dealProducts[index],
        ...getProductCommonFields({ products, product, provider, rate: updateRate, plan, option }),
      };
    }
  });
  products.removedProducts?.forEach(({dealProductId, productTypeId}) => {
	if (productTypeId && !products.deductiblesSelected.has(productTypeId) && !products.dealsProductsMap.has(productTypeId) && dealProductId) {
		dealProducts.push({
			dealId,
			dealProductId,
			productTypeId,
			plan: null,
			rate: null
		});
	}
  });
  return { dealProducts };
};



export const getPostDataToSaveGetPlans = (products: SelectedRetails, customData?: ICustomData) => {

 // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const data: any = {
    lenderCode: customData?.data.lenderCode,
    dealCalculatorLeadProductDtos: [],
  };

  const getDedupeKey = (item: DealProduct | IProductCommonFields) => `${item.productTypeId}__${item.rate?.rateId}`;

  const existingKeys = new Set<string>();

  products.dealsProductsMap.forEach((product: DealProduct) => {
    data.dealCalculatorLeadProductDtos.push(product);
    existingKeys.add(getDedupeKey(product));
  });

  products.deductiblesSelected.forEach(({ product, provider, plan, rate, option, dealCalculatorLeadProductId }) => {
    const commonFields = getProductCommonFields({ products, product, provider, rate, plan, option });
    const dedupeKey = getDedupeKey(commonFields);

    if (existingKeys.has(dedupeKey)) return;

    data.dealCalculatorLeadProductDtos.push({
      lenderCode: customData?.data.lenderCode,
      dealCalculatorLeadProductId: dealCalculatorLeadProductId || null,
      taxAmount: 0,
      sefiTermId: 0,
      sefiContractFormNumber: '',
      ...commonFields,
    });

    existingKeys.add(dedupeKey);
  });

  products.removedProducts?.forEach(({ dealCalculatorLeadProductId, productTypeId }) => {
    if (
      productTypeId &&
      !products.deductiblesSelected.has(productTypeId) &&
      !products.dealsProductsMap.has(productTypeId) &&
      dealCalculatorLeadProductId
    ) {
      data.dealCalculatorLeadProductDtos.push({
        lenderCode: customData?.data.lenderCode,
        dealCalculatorLeadProductId,
        productTypeId,
        plan: null,
        rate: null,
      });
    }
  });

  return data;
};